import { createSelector } from "reselect";
import {
  selectBusinessIdByAuctionsPlusCodeLookup,
  selectBusinessIdBySaleyardCodeLookup,
} from "./indexes";
import {
  selectAuctionsPlusCsvBusinessImportStoredMapping,
  selectSg8BusinessImportStoredMapping,
} from "./root";

export const selectBusinessIdByImportSaleyardCodeLookup = createSelector(
  [selectSg8BusinessImportStoredMapping, selectBusinessIdBySaleyardCodeLookup],
  (sg8StoredMapping, businessIdBySaleyardCode) => {
    const lookup = {};

    // First apply saleyard code fallback
    for (const code in businessIdBySaleyardCode) {
      lookup[code] = businessIdBySaleyardCode[code];
    }

    // Override with storedMapping where available
    for (const code in sg8StoredMapping) {
      const businessId = sg8StoredMapping[code]?.businessId;
      if (businessId) {
        lookup[code] = businessId;
      }
    }

    return lookup;
  },
);

export const selectBusinessIdByImportAuctionsPlusCodeLookup = createSelector(
  [
    selectAuctionsPlusCsvBusinessImportStoredMapping,
    selectBusinessIdByAuctionsPlusCodeLookup,
  ],
  (auctionsPlusStoredMapping, businessIdByAuctionsPlusCode) => {
    const lookup = {};

    // First apply auctions plus code fallback
    for (const code in businessIdByAuctionsPlusCode) {
      lookup[code] = businessIdByAuctionsPlusCode[code];
    }

    // Override with storedMapping where available
    for (const code in auctionsPlusStoredMapping) {
      const businessId = auctionsPlusStoredMapping[code]?.businessId;
      if (businessId) {
        lookup[code] = businessId;
      }
    }

    return lookup;
  },
);
